import React from 'react';
interface ProgressBarProps {
  current: number;
  total: number;
}
const ProgressBar: React.FC<ProgressBarProps> = ({
  current,
  total
}) => {
  const percentage = current / total * 100;
  return <div className="bg-gray-800 text-white p-4" data-id="element-37">
      <div className="flex justify-between items-center mb-2" data-id="element-38">
        <span className="text-sm font-medium" data-id="element-39">
          Exercise {current} of {total}
        </span>
        <span className="text-sm font-medium" data-id="element-40">
          {Math.round(percentage)}% Complete
        </span>
      </div>
      <div className="h-2 bg-gray-600 rounded-full overflow-hidden" data-id="element-41">
        <div className="h-full bg-green-500 transition-all duration-300 ease-in-out" style={{
        width: `${percentage}%`
      }} data-id="element-42"></div>
      </div>
    </div>;
};
export default ProgressBar;